// extracted by mini-css-extract-plugin
export default {"header":"Header_header__HXQOm","headerNoLogo":"Header_headerNoLogo__5BBYS","socials":"Header_socials__Xt3tA","icon":"Header_icon__KAtlG"};